export default __webpack_public_path__ + "static/media/Background_00099.e4e56d86.png";